'use strict';

// utility class
import ApplyClass from '../Utils/ApplyClass';

import Form from '../Controller/Form';


import Validate from '../View/Form/Validate';
import Submit from '../View/Form/Submit';
import ZenkakuToHankaku from '../View/Form/ZenkakuToHankaku';
import TelephoneNumber from '../View/Form/TelephoneNumber';
import AutoKana from '../View/Form/AutoKana';
import ShowPassword from '../View/Form/ShowPassword';
import CreateYear from '../View/Form/CreateYear';
import CreateCardYear from '../View/Form/CreateCardYear';
import ChangeDate from '../View/Form/ChangeDate';
import CheckAgree from '../View/Form/CheckAgree';
import PostalCode from '../View/Form/PostalCode';
import ChangeRegister from '../View/Form/ChangeRegister';
import RadioGroup from '../View/Form/RadioGroup';
import CheckToggle from '../View/Form/CheckToggle';
import HasCounter from '../View/Form/HasCounter';
import ChangeInquiryType from '../View/Form/ChangeInquiryType';
import SplitBirthday from '../View/Form/SplitBirthday';
import SplitBirthday2 from '../View/Form/SplitBirthday2';
import AddFavoriteShop from '../View/Form/AddFavoriteShop';
import ChangeNoshiType from '../View/Form/ChangeNoshiType';
import Select2 from '../View/Form/Select2';
import FormAutoSubmit from '../View/Form/FormAutoSubmit';
import FormChangePaymentType from '../View/Form/ChangePaymentType';
import ChangeInvoiceName from '../View/Form/ChangeInvoiceName'

// のし暫定対応
import DeleteNoshiType from '../View/Form/DeleteNoshiType';
import DeleteWrappingOfNoshiType from '../View/Form/DeleteWrappingOfNoshiType';

// のし管理実装対応
import ChangeNoshiType2 from '../View/Form/ChangeNoshiType2';

$(() => {
	const FormController = new Form();
	// validate
	$('.validate').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Validate, $e, [$e, FormController]);
	});
	// 全角→半角変換
	$('.zen2han').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ZenkakuToHankaku, $e, [$e, FormController]);
	});
	// 電話番号
	$('.tel-no').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(TelephoneNumber, $e, [$e, FormController]);
	});
	// submit
	$('[type=submit][data-form]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Submit, $e, [$e, FormController]);
	});
	//カナ自動入力
	$('.name-wrap').each(function (idx, e) {
		const $e = $(e);
		const $name_sei = $e.find('.name_sei');
		const $name_mei = $e.find('.name_mei');
		const $name_sei_kana = $e.find('.name_sei_kana');
		const $name_mei_kana = $e.find('.name_mei_kana');
		const $receiver_name_sei = $e.find('.receiver_name_sei');
		const $receiver_name_mei = $e.find('.receiver_name_mei');
		const $receiver_name_sei_kana = $e.find('.receiver_name_sei_kana');
		const $receiver_name_mei_kana = $e.find('.receiver_name_mei_kana');
		const $corporate_name = $e.find('.corporate_name');
		const $corporate_name_kana = $e.find('.corporate_name_kana');
		ApplyClass.apply(AutoKana, $name_sei, [$name_sei, $name_sei_kana, FormController]);
		ApplyClass.apply(AutoKana, $name_mei, [$name_mei, $name_mei_kana, FormController]);
		ApplyClass.apply(AutoKana, $receiver_name_sei, [$receiver_name_sei, $receiver_name_sei_kana, FormController]);
		ApplyClass.apply(AutoKana, $receiver_name_mei, [$receiver_name_mei, $receiver_name_mei_kana, FormController]);
		ApplyClass.apply(AutoKana, $corporate_name, [$corporate_name, $corporate_name_kana, FormController]);
	});
	// パスワード表示
	$('.anchor--show-password').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ShowPassword, $e, [$e, FormController]);
	});
	// 年作成
	$('.create-year').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CreateYear, $e, [$e, FormController]);
	});
	// カード年作成
	$('#expired_year').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CreateCardYear, $e, [$e, FormController]);
	});
	// 日付変更
	$('.change-date').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeDate, $e, [$e, FormController]);
	});
	// 規約同意
	$('#agree').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckAgree, $e, [$e, FormController]);
	});
	// 酒類20歳以上同意
	$('#age-verification').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckAgree, $e, [$e, FormController]);
	});
	// 郵便番号分割
	$('.p-postal-code').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(PostalCode, $e, [$e, FormController]);
	});
	// 無料会員登録
	$('[name=registration]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeRegister, $e, [$e, FormController]);
	});
	// ラジオグループ
	$('.radio-group').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(RadioGroup, $e, [$e, FormController]);
	});
	// チェックボックス
	$('.check-toggle').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(CheckToggle, $e, [$e, FormController]);
	});
	// 文字カウンター
	$('.has-counter').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(HasCounter, $e, [$e, FormController]);
	});
	// お問合せ種別変更
	$('.inquiry_type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeInquiryType, $e, [$e, FormController]);
	});
	// 誕生日分割
	$('#birthday').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SplitBirthday, $e, [$e, FormController]);
	});
	// 誕生日分割
	$('.celebration_message_birthday').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(SplitBirthday2, $e, [$e, FormController]);
	});
	// お気に入り店舗追加
	$('.page-order-confirm').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(AddFavoriteShop, $e, [$e, FormController]);
	});
	// のし種別変更
	$('.noshi_type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeNoshiType, $e, [$e, FormController]);
	});
	// のし種別削除
	$('.noshi_type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DeleteNoshiType, $e, [$e, FormController]);
	});
	// のしの掛け方削除
	$('.wrapping_of_noshi_type').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(DeleteWrappingOfNoshiType, $e, [$e, FormController]);
	});
	// のしの掛け方選択肢変更
	$('.noshi_type_2').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeNoshiType2, $e, [$e, FormController]);
	});
	// select2
	$('.select2').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(Select2, $e, [$e, FormController]);
	});
	// 外部決済画面遷移時のフォーム自動送信
	$('.form-auto-submit').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FormAutoSubmit, $e, [$e, FormController]);
	});
	// お支払い方法選択肢変更
	$('input[name=select_payment_type]').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(FormChangePaymentType, $e, [$e, FormController]);
	});
	// インボイス宛名入力
	$('#invoice-name').each((idx, e) => {
		const $e = $(e);
		ApplyClass.apply(ChangeInvoiceName, $e, [$e, FormController]);
	});
});
